import { Record } from "appworks/model/gameplay/records/record";
import { ResultBuilder } from "appworks/server/builders/result-builder";
import { FowlSlotBonusResult } from "model/results/fowl-slot-bonus-result";
import { SlingoResponse } from "slingo/integration/slingo-schema";
import { BonusResult } from "slotworks/model/gameplay/records/results/bonus-result";

export class FowlSlotBonusResultBuilder implements ResultBuilder {
    public filter(data: SlingoResponse, record?: Record, additionalData?: any): boolean {
        return Boolean(data?.spinResult?.feature?.slots);
    }

    public build(record: Record, data: SlingoResponse, additionalData?: any): BonusResult[] {
        const result = new FowlSlotBonusResult("slotbonus");
        result.totalSpins = data.spinResult.feature.slots.spins.length;
        return [result];
    }
}
